import { render, staticRenderFns } from "./VPath.vue?vue&type=template&id=51c9613a&"
import script from "./VPath.vue?vue&type=script&lang=ts&"
export * from "./VPath.vue?vue&type=script&lang=ts&"
import style0 from "./VPath.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports